import React, { useState, useRef } from "react";
import { MultiSelect } from "react-multi-select-component";
import { Row, Col } from "react-bootstrap";

import axios from "axios";

import { Toast } from "primereact/toast";

import { main_link } from "../Connection/Connection";

const AddSchedule = (props) => {
  const setCounter = props.setCounter;
  const counter = props.counter;

  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [days, setDays] = useState([]);
  const [start_time, setStart_time] = useState("10:00");
  const [end_time, setEnd_time] = useState("22:00");

  const weekDays = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
  ];

  const add = async () => {
    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user["encrypted_id"];

    setLoading(true);

    const daysArray = [];

    days.forEach((element) => {
      const temp_days_value = element["value"];
      daysArray.push(temp_days_value);
    });

    try {
      const response = await axios.post(main_link + "addSchedule", {
        name,
        daysArray,
        description,
        start_time,
        end_time,
        user_id,
      });

      setLoading(false);
      console.log(response.data);

      if (response.data.message == "Added Successfully.") {
        document.getElementById("add-new-schedule").reset();
        $("#add-schedule").modal("hide");
        setCounter(counter + 1);

        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Added Successfully.",
        });
      } else {
      }
    } catch (error) {
      setLoading(false);
      let errorMessage = "";
      Object.values(error.response.data.errors).forEach((errorArray) => {
        errorArray.forEach((error) => {
          errorMessage += error + "\n";
        });
      });
      // setMsg(errorMessage);
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: errorMessage,
      });
    }
    setLoading(false);
  };
  return (
    <>
      <Toast ref={toast} />{" "}
      <div className="modal fade" id="add-schedule">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Work Sechdule</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="add-new-schedule">
                <Row>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="name">Sechdule Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Sechdule Name"
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="days">Sechdule Days</label>
                      <MultiSelect
                        options={weekDays}
                        value={days}
                        onChange={setDays}
                        labelledBy="Select"
                        style={{ backgroundColor: "red" }}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="end">End Time</label>
                      <input
                        type="time"
                        className="form-control"
                        id="end"
                        onChange={(e) => setEnd_time(e.target.value)}
                        defaultValue="22:00"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="note">Notes</label>
                      <small style={{ fontSize: "10px", color: "green" }}>
                        "This description will not be shown in the table on the
                        main page.
                      </small>
                      <textarea
                        className="form-control"
                        rows={3}
                        placeholder="Any Description ..."
                        defaultValue={""}
                        id="note"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
              </form>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default border-primary"
                data-dismiss="modal"
              >
                Close
              </button>
              {!loading && (
                <button type="button" className="btn btn-primary" onClick={add}>
                  Create
                </button>
              )}
              {loading && (
                <button type="button" className="btn btn-primary" disabled>
                  Creating...
                </button>
              )}
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
    </>
  );
};

export default AddSchedule;
